<template>
  <div class="left-sec sec min-mobile1" id="gomain">
    <div class="content2">
      <h3 class="head">{{ $t("auth.welcome") }}</h3>
      <p class="text">
        {{ infoText }}
      </p>
    </div>
  </div>
</template>

<script setup>
import { ref, onMounted } from "vue";
import i18n from "@/i18n";

// reactive state
const infoText = ref(i18n.global.t(`auth.welcomephase`));

// functions that mutate state and trigger updates
// function increment() {
//   count.value++;
// }

// lifecycle hooks
onMounted(() => {
  // console.log(`mounted`);
});
</script>
